let currentUrl = window.location.href;
let lastVariantId = null;
const skuEl = document.getElementById("sku");
const eanEl = document.getElementById("ean");

const metafieldScript = document.querySelector(
  '[id^="product__metafield_for_variant-block"]'
);

let variantMetafields = {};
if (metafieldScript) {
  try {
    variantMetafields = JSON.parse(metafieldScript.textContent.trim());
  } catch (e) {
    console.error("Fehler beim Parsen der Variant-Metafelder:", e);
  }
}

lastVariantId =
  new URLSearchParams(window.location.search).get("variant") || null;

setInterval(() => {
  if (window.location.href !== currentUrl) {
    const metafieldScript = document.querySelector(
      '[id^="product__metafield_for_variant-block"]'
    );
    console.log("Metafield script: ", metafieldScript);

    const productJsonEl = document.getElementById("ProductJson");
    if (!productJsonEl) {
      currentUrl = window.location.href;
      return;
    }
    const productData = JSON.parse(productJsonEl.textContent);
    //console.log(productData);

    currentUrl = window.location.href;
    const variant = new URLSearchParams(window.location.search).get("variant");
    //console.log("Neue Variant-ID erkannt:", variant);

    const eanSkuObj = document.getElementById("eanSkuContainer");
      if (eanSkuObj) {
        const eanJson = JSON.parse(eanSkuObj.textContent);
        const eanSkuData = eanJson?.[variant];
        if (eanSkuData && skuEl && eanEl) {
          skuEl.innerText = eanSkuData.sku || "";
          eanEl.innerText = eanSkuData.ean || "";
        }
      }
    

    //displaying the inventoryNotice text conditionally
    const inventoryNotice = document.querySelector(
      ".product__inventory-notice"
    );
    if (inventoryNotice) {
      const inventoryNumber = inventoryNotice.textContent.match(/(\d+)/);
      const inventoryCount = Number(inventoryNumber?.[0] || 0);
      console.log("Inventory number: ", inventoryNumber);
      if (inventoryCount <= 15 && inventoryCount > 0) {
        inventoryNotice.classList.remove("hidden");
      } else if (inventoryCount === 0) {
        console.log(inventoryNotice.childNodes);
        inventoryNotice.classList.remove("hidden");
      }
    }
    

    /**
     * Lieferzeit auf der PDP + Add-to-Cart-Property, wenn sich die URL (z. B. ?variant=) ändert:
     * Section-Rendering "render-product-lieferung-details" mit gewählter Varianten-ID; wir
     * übernehmen .delivery-info-text ins Layout und setzen input[name="properties[Lieferzeit]"]
     * auf denselben Klartext, damit der nächste In-den-Warenkorb-Submit die passende Line-Property mitschickt.
     */
    const productLieferungDetails = document.querySelector(
      "[data-product-lieferung-details-root]"
    );
    if (productLieferungDetails ) {
      const variantId = variant || String(productData.selected_or_first_available_variant?.id || "");
      if (!variantId || !productData.handle) return;
      if (variantId === lastVariantId) return;
      lastVariantId = variantId;

      const productPath = window.location.pathname.split("?")[0];
      const params = new URLSearchParams({
        section_id: "render-product-lieferung-details",
        variant: variantId,
      });

      fetch(`${productPath}?${params.toString()}`)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const el = doc.querySelector("[data-product-lieferung-details-root]");
          const remoteText = el?.querySelector(".delivery-info-text");
          const localText = productLieferungDetails.querySelector(
            ".delivery-info-text"
          );
          if (remoteText && localText) {
            localText.innerHTML = remoteText.innerHTML;
            const lieferzeitInput = document.querySelector(
              'input[name="properties[Lieferzeit]"]'
            );
            if (lieferzeitInput) {
              const trimedValue = remoteText.textContent.trim();
              if(trimedValue.includes("Lieferzeit: ")) {
                lieferzeitInput.value = trimedValue.replace("Lieferzeit: ", "");
              } else {
                lieferzeitInput.value = trimedValue;
              }
            }
          }
        })
        .catch(() => {});
    }
  }
}, 500);
